require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/~/core-js/library/modules/es7.symbol.observable.js
// module id = 982
// module chunks = 0